import { useEffect, useState } from 'preact/hooks';
import QRCode from 'qrcode';
import { api, guardarToken } from '../api';

/** Activación del segundo factor: se muestra la clave para la app de autenticación y se confirma con un código. */
export function Configurar2fa({ alListo }: { alListo: () => void }) {
  const [uri, setUri] = useState('');
  const [codigo, setCodigo] = useState('');
  const [error, setError] = useState('');
  const [qr, setQr] = useState('');
  useEffect(() => { api<{ uri: string }>('/api/sesion/2fa/configurar', { metodo: 'POST' }).then(async (r) => { setUri(r.uri); setQr(await QRCode.toString(r.uri, { type: 'svg', margin: 1, width: 200 })); }).catch((e) => setError(e.message)); }, []);
  const secreto = uri.match(/secret=([A-Z2-7]+)/)?.[1] ?? '';
  async function confirmar(e: Event) {
    e.preventDefault(); setError('');
    try { const r = await api<{ token: string }>('/api/sesion/2fa/confirmar', { cuerpo: { codigo } }); guardarToken(r.token); alListo(); } catch (err) { setError((err as Error).message); }
  }
  return (
    <div class="tarjeta relleno" style="max-width:560px;display:flex;flex-direction:column;gap:12px">
      <h2>Activa tu segundo factor</h2>
      <p style="margin:0">Para emitir y firmar documentos necesitas una aplicación de autenticación (Google Authenticator, Microsoft Authenticator, 1Password o similar). Escanea el código o agrega una cuenta "introduciendo una clave":</p>
      {qr && <div style="width:200px;height:200px;background:#fff;padding:4px;border:1px solid var(--linea)" dangerouslySetInnerHTML={{ __html: qr }} />}
      <div class="num" style="font-size:20px;font-weight:700;letter-spacing:2px;word-break:break-all;background:var(--fondo);padding:12px;border-radius:6px">{secreto ? secreto.match(/.{1,4}/g)!.join(' ') : '…'}</div>
      <div class="sub">Tipo: basado en tiempo (TOTP), 6 dígitos, 30 segundos. Si tu aplicación acepta enlaces, también sirve este: <a href={uri}>{uri.slice(0, 60)}…</a></div>
      <form onSubmit={confirmar} class="fila" style="align-items:flex-end">
        <div class="campo" style="flex:1 1 200px"><label for="c2">Código que muestra la aplicación</label><input id="c2" inputMode="numeric" required value={codigo} onInput={(e) => setCodigo((e.target as HTMLInputElement).value)} /></div>
        <button class="boton marino" type="submit">Activar</button>
      </form>
      {error && <div class="error">{error}</div>}
    </div>
  );
}
